var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1268_5597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64527 2.35156L0.94227 10.0551C0.903516 10.094 0.875534 10.1431 0.862209 10.1958L0.00840497 13.6228C-0.0171348 13.726 0.0131798 13.8357 0.0884664 13.9109C0.145431 13.9679 0.22305 13.9994 0.302445 13.9994C0.326763 13.9994 0.351636 13.9964 0.375844 13.9903L3.80283 13.1364C3.85624 13.1231 3.90477 13.0952 3.94352 13.0565L11.6472 5.35348L8.64527 2.35156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5563 1.30172L12.6988 0.444257C12.1258 -0.128832 11.1269 -0.128277 10.5545 0.444257L9.50415 1.49461L12.506 4.49641L13.5563 3.44606C13.8426 3.15991 14.0003 2.77903 14.0003 2.37395C14.0003 1.96887 13.8426 1.58799 13.5563 1.30172Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_5597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.3d326b473d960995298f6d444917fdd8.svg";
export { ForwardRef as ReactComponent };